var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.deluxeInfo)?_c('div',{staticClass:"deluxe-result-manager-base"},[_c(_vm.targetComponent,{tag:"component",attrs:{"item-name":_vm.itemName,"item-price":_vm.itemPrice,"subsc-price":_vm.subscPrice,"subsc-url":_vm.subscUrl,"is-subsc-active":_vm.isSubscActive,"free-flg":_vm.freeFlg,"deluxe-info":_vm.deluxeInfo,"buy-link":_vm.buyLink}})],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40218e44","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/deluxe/DeluxeResultManager.vue
// module id = null
// module chunks = 